import React from "react";
import Select from "react-select";

// const options = [
//   { value: { id: 1, name: "roy" }, label: "Roy" },
//   { value: { id: 2, name: "Tom" }, label: "Tom" },
// ];

class SelectBoxSearchAssetItem extends React.Component {
 state = {
    selectedItem: this.props.selectedItem,
  };

  // componentDidMount() {
  //   if()
  // }

  componentDidUpdate(prevProps) {

    if (prevProps.selectedItem !== this.props.selectedItem) {
      this.setState({
        selectedItem: this.props.selectedItem,
      });
    }
  }
  
  handleChange = (selectedItem) => {
    this.setState({ selectedItem });

    this.props.setSelectedOption(selectedItem)
    //this.props.onChange(selectedOption);
  };

  render() {
    const { selectedItem } = this.state.selectedItem;
    const { options } = this.props;
    return (
      <Select
        value={this.props.selectedItem}
        onChange={this.handleChange}
        options={options}
      />
    );
  }
}

export default SelectBoxSearchAssetItem;
